import { render } from "./leads-active.vue?vue&type=template&id=0552c5f5"
import script from "./leads-active.vue?vue&type=script&lang=js"
export * from "./leads-active.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__